export function debounce(func, timeout = 300) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            func.apply(this, args);
        }, timeout);
    };
}

export function randomString(length) {
    return Math.random().toString(20).substr(2, length);
}

export function truncateWords(text, maxWordLength = 20) {
    if (!text) {
        return text;
    }

    return text
        .split(' ')
        .map(w => truncate(w, maxWordLength))
        .join(' ');
}

export function truncate(text, length = 20) {
    if (!text) {
        return text;
    }

    const appends = '...';
    if (text.length <= length - appends.length) {
        return text;
    }

    return text.substring(0, length - appends.length) + appends;
}

export function stripTags(html) {
    // https://stackoverflow.com/a/5002161
    if (!html) {
        return html;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    return doc.body.textContent || '';
}

export function ucfirst(str) {
    if (!str) return str;

    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Uppercase the first letter of each word
 * @param str
 */
export function ucallwords(str) {
    return str
        .split(' ')
        .map(w => ucfirst(w))
        .join(' ');
}

/**
 * This ensures that url cannot be used in a DOMXSS attack if used as an href
 * @param url
 * @returns {*}
 */
export function secureHref(url) {
    if (typeof url?.startsWith !== 'function') {
        return url;
    }

    if (url?.startsWith('http') || url?.startsWith('/')) {
        return url;
    } else {
        return null;
    }
}

export function sumProperty(arrayOfObjects, property) {
    return arrayOfObjects.reduce(
        (total, obj) => total + (obj[property] || 0),
        0,
    );
}

export function trimEndChar(str, char) {
    if (!str?.length) {
        return str;
    }

    if (str[str.length - 1] === char) {
        return str.slice(0, -1);
    } else {
        return str;
    }
}

export function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
}

export function deepCopy(obj) {
    if (typeof structuredClone === 'function') {
        return structuredClone(obj);
    } else {
        return JSON.parse(JSON.stringify(obj));
    }
}

// Source: https://stackoverflow.com/a/13627586
export function ordinal_suffix_of(i) {
    let j = i % 10,
        k = i % 100;
    if (j === 1 && k !== 11) {
        return i + 'st';
    }
    if (j === 2 && k !== 12) {
        return i + 'nd';
    }
    if (j === 3 && k !== 13) {
        return i + 'rd';
    }
    return i + 'th';
}

/**
 * Gets a cookie value by name
 * @param {string} name - The name of the cookie to retrieve
 * @returns {string|null} The cookie value or null if not found
 */
export function getCookie(name) {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        // Check if this cookie string begins with the name we want
        if (cookie.substring(0, name.length + 1) === name + '=') {
            return decodeURIComponent(cookie.substring(name.length + 1));
        }
    }
    return null;
}

export function uniqueArray(arr) {
    return [...new Set(arr)];
}

export function ensureObjectArray(obj) {
    if (Array.isArray(obj)) {
        return obj;
    } else if (typeof obj === 'object') {
        return Object.values(obj);
    } else {
        return obj;
    }
}
